import React from "react";

export default function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-background"></div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">NARMADA SOLAR SOLUTIONS</h1>
        <p className="hero-tagline">
          (Your trusted partner for sustainable solar energy solutions)
        </p>
      </div>
    </section>
  );
}
